import { ActionTree } from 'vuex';
import { userAuthServiceApi } from './callers';
import {
  FETCH_CURRENT_USER_ROLE_PERMISSIONS,
  PermissionsState,
  SET_CURRENT_USER_ROLE_PERMISSIONS
} from './types';

const actions: ActionTree<PermissionsState, Record<string, never>> = {
  async [FETCH_CURRENT_USER_ROLE_PERMISSIONS]({ commit }): Promise<void> {
    return userAuthServiceApi
      .getRoleV2()
      .then((response) => {
        commit(FETCH_CURRENT_USER_ROLE_PERMISSIONS, response);
      })
      .catch(() => {
        commit(SET_CURRENT_USER_ROLE_PERMISSIONS, []);
      });
  }
};

export default actions;
